export default {
  apiBaseUrl: '/api',
  logJamBaseUrl: '/logjam',
};
